import {
  IAttributes,
  IAugmentedJQuery,
  IComponentOptions,
  IController,
  IDocumentService,
  INgModelController,
  IScope
} from 'angular';
import { checkInsideClick } from '../../../helpers/check-inside-click';
import { isEmailValid, isPhoneValid } from '../../../helpers/validators';
import './gmc-status-input-notlock.component.scss';

export interface IStatusOption {
  id?: number;
  icon?: string;
  name?: string;
  style?: string
}

export interface IStatusValue {
  _id?: string;
  value?: string;
  show?: number;
}


export class GmcStatusInputController implements IController {
  static $inject = [
    '$element',
    '$attrs',
    '$document',
    '$scope'
  ];
  value = '';
  isOpened = false;
  options: {
    [id: number]: IStatusOption;
  };
  currentStatus: IStatusOption = {};
  inputId: string;
  placeholder = 'Enter text';
  ngModel: INgModelController;
  readonly = false;



  constructor(private $element: IAugmentedJQuery,
    public $attrs: IAttributes,
    private $document: IDocumentService,
    private $scope: IScope) {
    this.documentClickListener = this.documentClickListener.bind(this);
    this.initData();
  }

  $onInit() {
    this.initOutsideClickListener();
  }

  onInputChange() {
    this.ngModel.$setViewValue(this.value);
  }

  $onDestroy() {
    this.$document.off('click', this.documentClickListener);
  }

  $postLink() {
    this.ngModel.$overrideModelOptions({
      allowInvalid: true
    });
    this.ngModel.$formatters.push((value: IStatusValue = {}) => {
      this.currentStatus = this.options[value.show] || this.options[1];
      return value.value;
    });

    this.ngModel.$parsers.push((value: string) => {
      this.ngModel.$modelValue.value = value;
      return this.ngModel.$modelValue;
    });

    this.ngModel.$render = () => {
      this.value = this.ngModel.$viewValue;
    };
    this.initValidators();
  }


  selectStatus(event, status: IStatusOption) {
    event.preventDefault();
    this.currentStatus = status;
    this.ngModel.$modelValue.show = status.id;
    this.toggle();
  }

  toggle() {
    this.isOpened = !this.isOpened;
  }

  private initData() {
    this.options = {
      0: {
        name: 'Hidden',
        icon: 'https',
        id: 0,
        style: "material-icons icon red "
      },
      1: {
        name: 'For Favorite',
        icon: 'lock_open',
        id: 1,
        style: "material-icons icon green"
      }
    };
  }

  private initValidators() {
    if (this.$attrs.type === 'email') {
      this.ngModel.$validators.email = (modelValue, viewValue) => {
        return !viewValue ? true : isEmailValid(viewValue);
      };
    }
    if (this.ngModel.$validators.required) {
      this.ngModel.$validators.required = (modelValue, viewValue) => {
        return viewValue && viewValue.trim().length > 0;
      };
    }
    if (this.$attrs.type === 'tel') {
      this.ngModel.$validators.tel = (modelValue, viewValue) => {
        return !viewValue ? true : isPhoneValid(viewValue);
      };
    }
  }

  private documentClickListener(event) {
    if (!this.isOpened) {
      return;
    }
    if (!checkInsideClick(this.$element[0], event)) {
      this.$scope.$apply(() => {
        this.isOpened = false;
      });
    }
  }

  changeClass() {

  }

  private initOutsideClickListener() {
    this.$document.on('click', this.documentClickListener);
  }

}

export const GmcStatusInputNotlockComponent: IComponentOptions = {
  controller: GmcStatusInputController,
  require: {
    ngModel: 'ngModel'
  },
  template: require('./gmc-status-input-notlock.component.html'),
  bindings: {
    statuses: '<?',
    inputId: '@?',
    placeholder: '@?',
    readonly: '<'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-status-input-notlock/gmc-status-input-notlock.component.ts